import { ProgressTracking } from "@/components/ProgressTracking";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

const Progress4 = () => {
  const navigate = useNavigate();

  return (
    <div className="relative min-h-screen bg-gray-50 p-8">
      <Button
        onClick={() => navigate("/")}
        variant="outline"
        className="mb-8"
      >
        Back to Home
      </Button>
      <ProgressTracking 
        familyName="Carroll Family"
        googleDriveUrl="https://drive.google.com/drive/folders/1FDaZ8U6q4tsosPGiNFmModP0_yugkLY6"
        password="carroll"
      />
    </div>
  );
};

export default Progress4;
